var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "orderList" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.afterSaleList.length > 0
      ? _c(
          "div",
          [
            _vm._l(_vm.afterSaleList, function(item, index) {
              return _c("div", { key: index, staticClass: "content" }, [
                _c("div", { staticClass: "top" }, [
                  _c("div", { staticClass: "left" }, [
                    _c(
                      "span",
                      {
                        staticClass: "shopName",
                        on: {
                          click: function($event) {
                            return _vm.toStore(item.shopId)
                          }
                        }
                      },
                      [
                        _c("img", { attrs: { src: item.shopLogo, alt: "" } }),
                        _vm._v(_vm._s(item.shopName))
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "orderCode" }, [
                      _vm._v("售后编号：" + _vm._s(item.afterFormid))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "productBox" }, [
                  _c("div", { staticClass: "product" }, [
                    _c(
                      "div",
                      { staticClass: "left fs13" },
                      _vm._l(item.skus, function(pro, inx) {
                        return _c("div", { key: inx, staticClass: "box" }, [
                          _c(
                            "div",
                            {
                              staticClass: "desc cur-poi",
                              on: {
                                click: function($event) {
                                  return _vm.toProductDetail(pro, item.shopId)
                                }
                              }
                            },
                            [
                              _c("img", { attrs: { src: pro.image, alt: "" } }),
                              _vm._v(" "),
                              _c("div", [
                                _c("p", { staticClass: "name" }, [
                                  _vm._v(_vm._s(pro.productName))
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "price" },
                            _vm._l(pro.values, function(val, idx) {
                              return _c("span", { key: idx }, [
                                _vm._v(_vm._s(val))
                              ])
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "price" }, [
                            _vm._v("¥" + _vm._s(pro.price))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "num" }, [
                            _vm._v(_vm._s(pro.number))
                          ])
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "right",
                        class: item.skus.length > 1 ? "right_line" : ""
                      },
                      [
                        _c("div", { staticClass: "actualPay" }, [
                          _c("div", [
                            _c("p", { staticClass: "fs13 mar-bot-5" }, [
                              _vm._v("¥" + _vm._s(item.price))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "applicationTime" }, [
                          _vm._v(_vm._s(item.createTime))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "status" }, [
                          _c("div", [
                            item.afterState == 1
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "fs13 mar-bot-5 font-color-FF7"
                                  },
                                  [_vm._v("审核中")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.afterState == 2
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "fs13 mar-bot-5 font-color-FF7"
                                  },
                                  [_vm._v("退款中")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.afterState == 3
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "fs13 mar-bot-5 font-color-FF7"
                                  },
                                  [_vm._v("退货中")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.afterState == 4
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "fs13 mar-bot-5 font-color-71B"
                                  },
                                  [_vm._v("退款成功")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.afterState == 5
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "fs13 mar-bot-5 font-color-FF7"
                                  },
                                  [_vm._v("退款失败")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.afterState == 6
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "fs13 mar-bot-5 font-color-FF7"
                                  },
                                  [_vm._v("审核不通过")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.afterState == 7
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "fs13 mar-bot-5 font-color-FF7"
                                  },
                                  [_vm._v("评审中")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.afterState == 8
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "fs13 mar-bot-5 font-color-999"
                                  },
                                  [_vm._v("退货完成，拒绝退款")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.afterState == 9
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "fs13 mar-bot-5 font-color-999"
                                  },
                                  [_vm._v("已关闭")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.afterState == 10
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "fs13 mar-bot-5 font-color-71B"
                                  },
                                  [_vm._v("审核通过")]
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "operate" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small" },
                                on: {
                                  click: function($event) {
                                    return _vm.toAfterSaleDetail(
                                      item.afterId,
                                      item.orderId
                                    )
                                  }
                                }
                              },
                              [_vm._v("售后详情")]
                            ),
                            _vm._v(" "),
                            item.afterState == 6 || item.afterState == 8
                              ? _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "throttle",
                                        rawName: "v-throttle"
                                      }
                                    ],
                                    staticClass:
                                      "fs13 tex-und cur-poi mar-top-10",
                                    on: {
                                      click: function($event) {
                                        return _vm.platform(
                                          item.afterId,
                                          item.orderId
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("申请平台介入")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ])
              ])
            }),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.page,
                "page-size": 5,
                background: "",
                layout: "prev, pager, next",
                total: _vm.total
              },
              on: { "current-change": _vm.handleCurrentChange }
            })
          ],
          2
        )
      : _c("div", { staticClass: "noorder" }, [
          _c("img", {
            attrs: {
              src: require("../../../static/image/noorder@2x.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "fs20 font-color-999" }, [
            _vm._v("您还没有售后订单哦～")
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head" }, [
      _c("div", { staticStyle: { flex: "9", "padding-left": "20px" } }, [
        _c("span", { staticStyle: { flex: "3" } }, [_vm._v("商品名称")]),
        _vm._v(" "),
        _c("span", { staticStyle: { flex: "2" } }, [_vm._v("商品属性")]),
        _vm._v(" "),
        _c("span", { staticStyle: { flex: "2" } }, [_vm._v("单价")]),
        _vm._v(" "),
        _c("span", { staticStyle: { flex: "2" } }, [_vm._v("数量")])
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { flex: "9", "padding-right": "20px" } }, [
        _c("span", { staticStyle: { flex: "1" } }, [_vm._v("退款金额")]),
        _vm._v(" "),
        _c("span", { staticStyle: { flex: "1" } }, [_vm._v("申请时间")]),
        _vm._v(" "),
        _c("span", { staticStyle: { flex: "1" } }, [_vm._v("状态")]),
        _vm._v(" "),
        _c("span", { staticStyle: { flex: "1" } }, [_vm._v("操作")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-356d2d9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-356d2d9a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/base/aftersaleList.vue
// module id = null
// module chunks = 